if (!customElements.get('cad-model')) {
  class CADModelGenerator extends HTMLElement {
    
    #acceptedFileTypes
    #fileUrl
  
    constructor() {
      super();
      this.container = this;
      
      this.elements = {
        runFilestackBtn: this.container.querySelector('#file_stack_trigger'),
        generateModelBtn: this.container.querySelector('.cadModelGenerator--generate'),
        cadModelWrapper: this.container.querySelector('.cadModelGenerator-wrapper')
      }

      this.#acceptedFileTypes = ['dxf', 'dwg', 'step', 'stp', 'iges', 'igs', 'sldprt', 'sldasm', 'x_t', 'x_b', 'svg'];
      
      this.init();
    }
  
    init() {
      this._initFileStack();
      this._initActions();
    }
  
    _initFileStack() {
      const client = filestack.init('AFYvIgplgTZq5xGOKla7nz');
  
      this.pickerOverlay = client.picker({
        onUploadDone: this.updateForm.bind(this),
        fromSources: ['local_file_system'],
        maxFiles: 1,
        maxSize: 50 * 1024 * 1024,
        uploadInBackground: true,
        displayMode: 'overlay',
        disableTransformer: true
      });
    }
  
    _initActions() {
      this.elements.runFilestackBtn.addEventListener('click', e => {
        e.preventDefault();
        this.pickerOverlay.open();
      });

      this.elements.generateModelBtn.addEventListener('click', () => this.generateModel());
    }

    generateModel() {
      if (!this.#fileUrl) return;
      if(this.elements.cadModelWrapper.querySelector('iframe')) this.elements.cadModelWrapper.querySelector('iframe').remove();

      this.elements.cadModelWrapper.insertAdjacentHTML('beforeend', `
        <iframe src="//sharecad.org/cadframe/load?url=${this.#fileUrl}" scrolling="no"> </iframe>
      `);

      this.updateStateOfButton(false);
    }
  
    updateForm (result) {
      const fileData = result.filesUploaded[0];
      const type = fileData.filename.split('.').pop().toLowerCase();

      if (!this.#acceptedFileTypes.includes(type)) {
        this.pickerOverlay.close();
        alert('File type not supported');
        return;
      }

      this.#fileUrl = fileData.url;
      this.updateStateOfButton();
    }

    updateStateOfButton(activate = true) {
      this.elements.generateModelBtn.disabled = !activate;
    }
  }

  customElements.define('cad-model-generator', CADModelGenerator);
}
